/* eslint-disable unicorn/prefer-module */
// Fuente única del logo de marca por país (10.1). Antes vivía inline en Container/index.js;
// SoloEscritorio lo reusa sin duplicar el mapeo.
export const getLogoByPais = (pais) =>
  ({
    Chile: require("../img/wecast-logo.png"),
    Perú: require("../img/visiona-logo.png"),
    Uruguay: require("../img/screenmedia-logo.png"),
    Region: require("../img/adigital-logo.png"),
  })[pais] || require("../img/visiona-logo.png");
